import { render, staticRenderFns } from "./FileDrop.vue?vue&type=template&id=2209add1&"
import script from "./FileDrop.vue?vue&type=script&lang=js&"
export * from "./FileDrop.vue?vue&type=script&lang=js&"
import style0 from "./FileDrop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VApp,VTooltip})
